import React from "react";

import { useTranslation } from "react-i18next";

import { useToast } from "hooks/toast";

import { markingService } from "services/marking";

import deleteIcon from "assets/hearingDetails/delete.svg";
import editIcon from "assets/hearingDetails/edit.svg";
import hideIcon from "assets/hearingDetails/hide.svg";
import showIcon from "assets/hearingDetails/show.svg";
import plusIcon from "assets/procedure/plus.svg";

import { IMark } from "./interface";
import {
  Container,
  FooterContainer,
  ContainerTiny,
  BottomMarkingTime,
  NewMarkingButton,
  ItemContainer,
  HeaderContainer,
  MarkingTime,
  HeaderTextContainer,
  MarkingTitle,
  MarkingDescription,
  IconsContainer,
  ContainerDelete,
} from "./styles";
import { StatusContainer, StatusText } from "../styles";

const Mark: React.FC<IMark> = ({
  marking,
  onDeleteMarking,
  onEditMarking,
  setOpenModal,
  processCuts,
  data = [],
  currentIndex,
  setCurrentIndex,
  onClickRefreshStatusCuts,
  isBeginin,
}) => {
  const { addToast } = useToast();
  const { t } = useTranslation();

  function retornarStatus(status: any) {
    switch (status) {
      case -1:
        return "";
      case 0:
        return t("markings.inQueue");
      case 1:
        return t("markings.loadingVideo");
      case 2:
        return t("markings.cuttingVideo");
      case 3:
        return t("markings.cut");
      case 4:
        return t("markings.videoLoadError");
      case 5:
        return t("markings.videoCutError");
      case 6:
        return t("markings.videoUploadError");
      default:
        return "";
    }
  }

  function secondsToTime(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = ("0" + minutes).slice(-2);
    const formattedSeconds = ("0" + remainingSeconds).slice(-2);
    const timeString = formattedMinutes + ":" + formattedSeconds;
    return timeString;
  }

  const handleProcessOrReloadCuts = () => {
    if (hasErrorInCuts()) {
      reloadCuts();
    } else {
      processCuts();
    }
  };

  const hasErrorInCuts = () => {
    if (data.length > 0) {
      const hasErrors = data?.find((x) => x.status >= 4 && x.status <= 6);
      if (hasErrors) {
        return true;
      }
      return false;
    }
  };

  async function reloadCuts() {
    try {
      const listAux: Array<any> = [];
      data.forEach((element) => {
        listAux.push({ ...element, status: 0 });
      });

      for (let i = 0; i < listAux.length; i++) {
        await markingService.patch(
          listAux[i].id?.toString(),
          "Status",
          listAux[i].status?.toString(),
        );
      }

      await refresgCuts();
    } catch {
      addToast({
        type: "error",
        title: t("marking.errorMaking"),
        description: t("common.unexpectedError"),
      });
      return false;
    }
  }

  async function refresgCuts() {
    if (onClickRefreshStatusCuts) await onClickRefreshStatusCuts();
  }

  return (
    <Container>
      <ContainerTiny id="container_tiny">
        {data.length ? (
          data.map((item, index) => (
            <ItemContainer selected={index === currentIndex} key={item?.id}>
              <HeaderContainer>
                <MarkingTime
                  onClick={() => marking.toggleMarkingTime(item.offSet1)}
                >
                  {secondsToTime(item.offSet1)}-{secondsToTime(item.offSet2)}
                </MarkingTime>
                <HeaderTextContainer>
                  <MarkingTitle>{`${
                    item.attendantName ? item.attendantName.split(" ")[0] : ""
                  }${
                    item.attendantName && item.status !== -1 ? " - " : ""
                  }${retornarStatus(item.status)}`}</MarkingTitle>

                  {(item.status === -1 || item.status === 3) && (
                    <IconsContainer>
                      {index === currentIndex && (
                        <ContainerDelete>
                          <img
                            alt=""
                            onClick={() => onEditMarking(item)}
                            src={editIcon}
                          />
                          <img
                            alt=""
                            onClick={() => onDeleteMarking(item)}
                            src={deleteIcon}
                          />
                        </ContainerDelete>
                      )}
                      <img
                        alt=""
                        onClick={() =>
                          setCurrentIndex(index === currentIndex ? -1 : index)
                        }
                        src={index === currentIndex ? hideIcon : showIcon}
                      />
                    </IconsContainer>
                  )}
                </HeaderTextContainer>
              </HeaderContainer>
              {index === currentIndex && (
                <MarkingDescription>{item.subject}</MarkingDescription>
              )}
            </ItemContainer>
          ))
        ) : (
          <StatusContainer>
            <StatusText>{t("markings.noMarkingsYet")}</StatusText>
          </StatusContainer>
        )}
      </ContainerTiny>
      <FooterContainer>
        <BottomMarkingTime>
          {Boolean(data?.find((x) => x.status === -1)) || hasErrorInCuts() ? (
            <NewMarkingButton
              style={{
                background: "#6fab7f",
              }}
              onClick={handleProcessOrReloadCuts}
            >
              <strong>
                {hasErrorInCuts() ? t("markings.reprocess") : t("markings.processCutsButton")}
              </strong>
            </NewMarkingButton>
          ) : (
            <div />
          )}
          <NewMarkingButton
            style={{
              background: isBeginin ? "#1D9BF0" : "#f5c242",
            }}
            onClick={() => {
              if (marking.playerState.playbackRate > 1) {
                addToast({
                  type: "warning",
                  title: t("marking.impossibleMaking"),
                  description: t("markings.speedWarning"),
                });
              } else {
                if (marking.playerState.playing) {
                  marking.toggleVideoPlay();
                }
                setOpenModal(true);
              }
            }}
          >
            <img src={plusIcon} alt="" />{" "}
            <strong style={{ marginLeft: 10 }}>
              {isBeginin ? t("markings.newMarking") : t("markings.finish")}
            </strong>
          </NewMarkingButton>
        </BottomMarkingTime>
      </FooterContainer>
    </Container>
  );
};

export default Mark;
